export default __webpack_public_path__ + "static/media/wrapper.5e53d5090f6027e8ab0b6b22239381da.svg";